import { FlexibleColumn } from '@ip-only/front-end-library';

const starredColumn: FlexibleColumn = {
  alignment: 'left',
  header: '',
  id: 'starredCol',
};

const ifsColumn: FlexibleColumn = {
  alignment: 'left',
  header: 'table.ifsCol',
  id: 'ifsCol',
};

const nameColumn: FlexibleColumn = {
  alignment: 'left',
  header: 'table.nameCol',
  id: 'nameCol',
};

const versionColumn: FlexibleColumn = {
  alignment: 'left',
  header: 'table.versionCol',
  id: 'versionCol',
};

const statusColumn: FlexibleColumn = {
  alignment: 'left',
  header: 'table.statusCol',
  id: 'statusCol',
};

const completeColumn: FlexibleColumn = {
  alignment: 'right',
  header: '',
  id: 'completeCol',
};

export const deliveryOverviewTableColumnsAll: FlexibleColumn[] = [
  starredColumn,
  ifsColumn,
  nameColumn,
  completeColumn,
];

export const deliveryOverviewTableColumnsStarred: FlexibleColumn[] = [
  starredColumn,
  ifsColumn,
  nameColumn,
  versionColumn,
  statusColumn,
  completeColumn,
];
